<template>
  <section v-if="hasAccept && link_uuid">

    <hr class="pb-0 mb-2 mt-2" />

    <span v-if="!accepted && !declined">
      <b-button variant="primary" class="btn-fill" @click="AcceptMeeting">
        {{ $t("MEETING_ACCEPT") }}
      </b-button>
      <b-button variant="danger" class="btn-fill" @click="DeclineMeeting">
        {{ $t("MEETING_DECLINE") }}
      </b-button>
    </span> 

  </section>
</template>
<script>
export default {
  props: ["authenticated", "link_uuid", "information"],
  data() {
    return {
      accepted: this.information.meeting_accepted,
      declined: this.information.meeting_declined,
      hasAccept: false
    };
  },
  methods: {
    async AcceptMeeting(){

    },
    async DeclineMeeting(){

    },
    async GetMeetingAccept() {
      /*if(this.IsMeeting(this.information.message.message_type))
      {
        try {
          let result = await this.$http.get(this.user.hostname + "/message/link/has-accept/" + this.link_uuid);
          this.hasAccept = result.data;
        } catch {
          console.log("Error GetOutOfOffice");
        }        
      }else{
        return false;
      }*/
    }
  },
  watch: {    
  },
  mounted() {
    this.GetMeetingAccept();
  },
};
</script>
<style lang="css"></style>
